
























import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import appModule from '@/model/store/modules/app-module';
import contentsModule from '@/model/store/modules/contents-module';
import detailModule from '@/model/store/modules/detail-module';
import aboutModule from '@/model/store/modules/about-module';
import headlineModule from '@/model/store/modules/headline-module';
import holidayModule from '@/model/store/modules/holiday-module';
import menuModule from '@/model/store/modules/menu-module';
import infomationModule from '@/model/store/modules/infomation-module';
import headerModule from '@/model/store/modules/header-module';
import userModule from '@/model/store/modules/user-module';
import userService from '@/model/services/user-service';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component
export default class ConfirmationDialog extends Vue {
  /** Data **/
  private display: boolean = false;
  private data: any; // 確定ボタン押下時に親側のイベントで使いたいデータ
  private feedbacks: any; // 確定ボタン押下時に親側のイベントで使いたいデータ
  private time: number = 3000;
  private type: string = '';

  /** Props **/
  @Prop({default: ''}) public title!: string;
  @Prop({default: ''}) public message!: string;

  get text() {
    return {
      confirmation: GlobalConstants.TEXT.SAVECONFIRMATION,
      confirm: GlobalConstants.TEXT.CONFIRM,
      cancel: GlobalConstants.TEXT.CANCEL
    };
  }

  /** Methods **/
  public open(param?: any): void {
    this.display = true;
    this.data = param.data; // 確定ボタンを押下した際に用いる情報
    this.feedbacks = param.feedbacks; // 確定ボタンを押下した際に用いる情報
    this.type = param.type;
  }

  public close(): void {
    this.display = false;
  }

  private onPushCancelBtn(): void {
    this.close();
  }

  @Emit('onPushEnterBtn')
  private async onPushEnterBtn(): Promise<void> {
    appModule.startLoading();
    this.close();
    userService.requestUserInfo();
    const func = _.debounce( async () => {
      switch (this.type) {
        case 'save':
          await contentsModule.requestUpsertContentsInfo(this.data);
          break;
        case 'allow':
          await Promise.all([
            contentsModule.requestUpsertContentsInfo(this.data)
          ]);
          break;
        case 'feedback':
          await Promise.all([
            contentsModule.requestUpsertContentsInfo(this.data)
          ]);
          break;
        case 'delete':
          if (this.data.isDelete) {
            await contentsModule.requestDeleteContentsInfo(this.data);
          }
          break;
        case 'categoryManageSave':
          await appModule.requestUpsertCategoryInfo(this.data);
          break;
        case 'aboutSave':
          await aboutModule.requestUpsertAboutInfo(this.data);
          break;
        case 'headlineSave':
          await headlineModule.requestUpsertHeadlineInfo(this.data);
          break;
        case 'menuSave':
          await menuModule.requestUpsertMenuInfo(this.data);
          break;
        case 'infomationSave':
          await infomationModule.requestUpsertInfomationInfo(this.data);
          break;
        case 'headerSave':
          await headerModule.requestUpsertHeaderInfo(this.data);
          break;
        case 'usersSave':
          await userModule.requestUpsertUserInfo(this.data);
          break;
        case 'headerDelete':
          await headerModule.requestDeleteHeaderInfo(this.data);
          break;
        case 'holidaySave':
          await holidayModule.requestUpsertHolidayInfo(this.data);
          break;
      }
      appModule.stopLoading();
    }, this.time);
    func();
  }
}
